'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _ExternalPaymentMethod = require('./ExternalPaymentMethod');

var _ExternalPaymentMethod2 = _interopRequireDefault(_ExternalPaymentMethod);

var _BrowserPaymentMethod = require('./BrowserPaymentMethod');

var _BrowserPaymentMethod2 = _interopRequireDefault(_BrowserPaymentMethod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CantPay = function CantPay() {
  return _react2.default.createElement(
    'div',
    null,
    'We are sorry; you are unable to pay at this time.'
  );
};

var PayExternally = (0, _recompose.branch)(function (_ref) {
  var walletType = _ref.walletType;
  return walletType === 'external';
}, (0, _recompose.renderComponent)(_ExternalPaymentMethod2.default));

var PayWithBrowser = (0, _recompose.branch)(function (_ref2) {
  var walletType = _ref2.walletType;
  return walletType === 'browser';
}, (0, _recompose.renderComponent)(_BrowserPaymentMethod2.default));

var PayWithLedger = (0, _recompose.branch)(function (_ref3) {
  var walletType = _ref3.walletType;
  return walletType === 'ledger';
}, (0, _recompose.renderComponent)(_BrowserPaymentMethod2.default));

var PaymentTerminal = (0, _recompose.compose)(PayExternally, PayWithBrowser, PayWithLedger)(CantPay);

exports.default = PaymentTerminal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/PaymentTerminal.js
// module id = 1262
// module chunks = 0